/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-03-19 20:30:46
 * @FilePath: /src/components/GlobalInitializerV2/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';
import { getGlobalInitData } from '@/api/public';
import { User } from '@/api/types/public';
import { useReporting } from '@/hooks/useReporting';
// import useThirdPartyLogin from '@/hooks/useThirdPartyLogin';
import { useStore } from '@/providers/app-store-provider';
import { ProviderType } from '@/reporting';
import appCommunicationManager, {
  EAppCommunicationFuncName,
} from '@/utils/app-communication-manager';
import logger from '@/utils/client-logger';
import { NO_SCROLL_TO_TOP_PAGE_LIST } from '@/utils/constants';
import { EPlatform } from '@/utils/enums/platform-enum';
import { env } from '@/utils/env';
import { getRouteCnName } from '@/utils/route-metadata';
import { isInZeloolApp } from '@/utils/tools';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { useAwinBindInit } from './useAwinBindInit';
import { usePepperjamBindInit } from './usePepperjamBindInit';
import { useEventListenInit } from './useEventListenInit';
import { useEventReportingInit } from './useEventReportingInit';
import { useImpactBindInit } from './useImpactBindInit';
import { useQueryParamsInit } from './useQueryParamsInit';
import { useStorageDataInit } from './useStorageDataInit';
import { useClientDataInit } from './useClientDataInit';
import { CommonCurrencyInfo } from '@/utils/currency/util-currency';

interface GlobalDataInitializerProps {
  currencyInfo?: CommonCurrencyInfo;
  accountInfo: User;
  deviceType: EPlatform;
}

/**
 * 组件用于初始化全局数据到Zustand store
 * 这是一个客户端组件，接收服务器端获取的数据
 */
const GlobalInitializer = ({
  currencyInfo,
  accountInfo,
  deviceType,
}: GlobalDataInitializerProps) => {
  const token = useStore((state) => state.token);
  const setPublicResourceData = useStore((state) => state.setPublicResourceData);
  const setInAppH5 = useStore((state) => state.setInAppH5);
  const setIsGlobalLoading = useStore((state) => state.setIsGlobalLoading);
  const pathname = usePathname();
  const prevPathname = useRef<string | null>(null);
  const prevToken = useRef<string | null>(null);
  const { trackEvent } = useReporting();

  // 初始化客户端逻辑
  useClientDataInit({ token, accountInfo, currencyInfo });

  // 初始化跟storage相关的处理
  useStorageDataInit();

  // 初始化事件监听
  useEventListenInit();

  // 初始化事件上报相关的处理
  useEventReportingInit({ deviceType });

  // 初始化query参数相关的处理
  useQueryParamsInit({ accountInfo });

  // 初始化Impact绑定处理
  useImpactBindInit();

  // 初始化Awin绑定处理
  useAwinBindInit();

  // 初始化 Pepperjam 绑定处理
  usePepperjamBindInit();

  // 初始化第三方登录处理 已经在 GlobalDialog 中进行加载了
  // useThirdPartyLogin();

  // 监听token变化，重新获取公共资源数据
  useEffect(() => {
    const refreshPublicResourceData = async () => {
      try {
        // 使用客户端版本的getGlobalInitData，与服务端保持一致
        const res = await getGlobalInitData(+deviceType === EPlatform.WEB, {
          info: [
            { key: 'product_config' },
            { key: 'show_my_card' },
            { key: 'cart_default_check_all' },
            { key: 'alive_lottery' },
            { key: 'register_gift' },
          ],
          block_type: ['13', '9'],
          blocks: [
            { block_type: 13, status: 1 },
            { block_type: 9, status: 1 },
          ],
          config_names: [
            'product_filter_new',
            'product_sort_new',
            'product_content_free_shipping_member',
            'product_content_half_price_member',
          ],
          country: true,
          country_site: true,
          crm_point: false,
          currency: true,
          ding_tong: true,
          half_price: false,
          ip_country: true,
          jsonvalues: [
            'user_info_collection_info',
            'instadesk_chat',
            'prescription_recognition_open',
            'customer_service_popup',
            'change_email_switch',
            'contact_chat_open_time',
            'cart_empty_navigation_config',
            'cart_FSA',
          ],
          member_levels: true,
          nav: { types: [1, 2] },
          wish_count: false,
          logo: true,
          notice: true,
          quick_entry: true,
        });

        // 更新store中的公共资源数据
        if (res && res.data) {
          // Map global init data to the expected resource structure
          const mappedRes = {
            info: res.data.info || {},
            config_names: res.data.config_names || {},
            jsonvalues: res.data.jsonvalues || {},
            blocks: res.data.block_types || {},
          };
          setPublicResourceData(mappedRes as any);
        }
      } catch (error) {
        logger.error('Failed to refresh public resource data after token change:', error);
      }
    };

    // 只有当token真正发生变化时才重新获取数据（排除初始化）
    if (prevToken.current !== null && prevToken.current !== token) {
      refreshPublicResourceData();
    }

    // 更新token记录
    prevToken.current = token;
  }, [token, setPublicResourceData]);

  useEffect(() => {
    if (isInZeloolApp()) {
      appCommunicationManager.sendMessage(EAppCommunicationFuncName.WEB_PAGE_INFO, {
        refer_page_name: getRouteCnName(pathname),
        refer_url_path: window.location.href,
      });
      setInAppH5(true);
    }
    // 只有在页面切换时才触发（排除首次加载）
    if (prevPathname.current !== null) {
      // 路由切换完成，关闭全局 Loading
      setIsGlobalLoading(false);

      // setIsWebPushed(true);
      // 这里等价于vue监听的$router.name

      // 切换页面的时候GA4更新页面数据
      const userId = localStorage.getItem('zl-userId') || '';
      if (window.gtag) {
        trackEvent(
          {
            commandType: 'config',
            eventName: env.NEXT_PUBLIC_GA4_MEASUREMENT_ID,
            properties: {
              page_path: pathname,
              page_location: location.origin + pathname,
            },
          },
          [ProviderType.GA4],
        );
        trackEvent(
          {
            commandType: 'set',
            eventName: env.NEXT_PUBLIC_GA4_MEASUREMENT_ID,
            properties: {
              page_path: pathname,
              page_location: location.origin + pathname,
            },
          },
          [ProviderType.GA4],
        );
        // 这种写法，没得兼容啊！所以只能用gtag原生的了
        window.gtag('set', { user_id: userId });
      }
      // 结束

      if (
        !NO_SCROLL_TO_TOP_PAGE_LIST.some((path) => {
          if (path === '/') {
            return pathname === '/';
          } else {
            return pathname === path || pathname?.startsWith(`${path}/`);
          }
        })
      ) {
        window.scrollTo(0, 0);
      }
    }
    // APPLOVIN的埋点上报
    trackEvent(
      {
        eventName: 'page_view',
      },
      [ProviderType.APPLOVIN],
    );

    // 更新前一个pathname
    prevPathname.current = pathname;
  }, [pathname, setIsGlobalLoading]);

  // 这个组件不需要渲染任何内容
  return null;
};

export default GlobalInitializer;
